// Casos unidos: al unir, el caso que se cierra recibe la nota "Unido al caso #N (asunto)." y el destino "Se unió el
// caso #N (asunto)." (api/casos.ts unirCasos). De esas notas salen los enlaces entre los dos casos.

type Nota = { texto: string };

const UNIDO_A = /Unido al caso #(\d{6,20})(?: \((.*)\))?\.?\s*$/;
const SE_UNIO = /Se unió el caso #(\d{6,20})(?: \((.*)\))?\.?\s*$/;

// A que caso se unio este (la ultima union, si se unio mas de una vez).
export function casoUnidoA(notas: Nota[] = []) {
  for (let i = notas.length - 1; i >= 0; i--) {
    const m = UNIDO_A.exec(notas[i].texto.trim());
    if (m) return { numero: m[1], asunto: m[2] ?? '' };
  }
  return null;
}

// Que casos se unieron a este, sin repetir, en el orden en que se unieron.
export function casosUnidosAqui(notas: Nota[] = []) {
  const vistos = new Map<string, string>();
  for (const n of notas) {
    const m = SE_UNIO.exec(n.texto.trim());
    if (m && !vistos.has(m[1])) vistos.set(m[1], m[2] ?? '');
  }
  return [...vistos].map(([numero, asunto]) => ({ numero, asunto }));
}
